import { AxiosInstance } from 'axios'

import {
  CreateEmployeesFamilyRequest,
  UploadEmployeeBirthCertificateRequest,
} from '@modules/employees/types/EmployeesFamilies/requests'
import { EmployeePerson } from '@modules/employees/types/EmployeesPersons/employeesPersons'

export class EmployeesFamiliesService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async create(data: CreateEmployeesFamilyRequest): Promise<EmployeePerson> {
    const { employeeId, ...body } = data

    const response = await this.instance.post(`/companies/employees/${employeeId}/families`, body)

    return response.data
  }

  async uploadBirthCertificate({ id, file }: UploadEmployeeBirthCertificateRequest): Promise<EmployeePerson> {
    const formData = new FormData()
    formData.append('certificate', file)

    const response = await this.instance.post(`/companies/employees/${id}/families/birth-certificate`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    return response.data
  }
}

export const employeesFamiliesService = (instance: AxiosInstance) => new EmployeesFamiliesService(instance)
